import { LocationStrategy } from '@angular/common';
import { Injectable } from '@angular/core';
import { Headers, Http, Response } from '@angular/http';
import { Router } from '@angular/router';
import { AuthGuard } from 'app/resources/services/auth-guard.service';
import { SessionService } from 'app/resources/services/session-service.service';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class HttpService {

    public location: Location;
    public path: string;

    constructor(public http: Http,
        private locationStrategy: LocationStrategy,
        public sessionService: SessionService,
        private guard: AuthGuard,
        private router: Router,
    ) {
        this.location = (<any>this.locationStrategy)._platformLocation.location;
    }

    private httpErros(): boolean {
        if (this.path == undefined || this.path == '') {
            throw new Error('path não informada');
        } else {
            return true;
        }

    }

    private httpHeader(header: any): Headers {
        const cabecalho: Headers = new Headers();

        if (header === undefined) {
            header = 'Content-Type';
        }

        if (typeof header === 'string') {
            if (header === 'Accept' || header === 'accept') {
                cabecalho.append('Accept', 'application/json');
            } else if (header === 'Content-Type' || header === 'content-type') {
                cabecalho.append('Content-Type', 'application/json');
            } else if (header === 'pdf') {
                cabecalho.append('Content-Type', 'application/pdf');
            }
        } else if (typeof header === 'object') {
            return header;
        }
        cabecalho.append('Authorization', 'Basic ' + this.sessionService.getAuthBasic());
        return cabecalho;
    }

    public get(url: string, autenticacao?: boolean, header?: any): Observable<Response> {
        let cabecalho: Headers = this.httpHeader(header);
        let retorno: Observable<Response>;

        if (this.httpErros()) {
            if (autenticacao) {
                retorno = this.http.get(this.path + url, { headers: cabecalho });
                this.path = '';
            } else {
                retorno = this.http.get(this.path + url);
                this.path = '';
                cabecalho = undefined;
            }
        }
        return this.guard.interceptor(retorno);
    }

    public put(url: string, body: any, autenticacao?: boolean,
        header?: any): Observable<Response> {
        let cabecalho: Headers = this.httpHeader(header);
        let retorno: Observable<Response>;

        if (this.httpErros()) {

            if (autenticacao) {
                retorno = this.http.put(this.path + url, body, { headers: cabecalho });
                this.path = '';
                cabecalho = undefined;

            } else {
                retorno = this.http.put(this.path + url, body);
                this.path = '';
            }
        }
        return this.guard.interceptor(retorno);
    }

    public post(url: string, body: any, autenticacao?: boolean,
        header?: any): Observable<Response> {

        let cabecalho: Headers = this.httpHeader(header);
        let retorno: Observable<Response>;

        if (this.httpErros()) {
            if (autenticacao) {
                retorno = this.http.post(this.path + url, body, { headers: cabecalho });
                this.path = '';
                cabecalho = undefined;
            } else {
                retorno = this.http.post(this.path + url, body);
                this.path = '';
            }
        }
        return this.guard.interceptor(retorno);
    }

    public delete(url: string, autenticacao?: boolean): Observable<Response> {
        let retorno: Observable<Response>;
        if (this.httpErros()) {
            if (autenticacao) {
                const cabecalho: Headers = this.httpHeader('Content-Type');
                retorno = this.http.delete(this.path + url, { headers: cabecalho });
            } else {
                retorno = this.http.delete(this.path + url);
            }
        }
        return this.guard.interceptor(retorno);
    }

    public invalidateSession() {
        this.sessionService = undefined;
    }

    private getUrl(tipo: string) {
        if (this.location.hostname === '127.0.0.1' || this.location.hostname === 'localhost') {
            return 'http://127.0.0.1:8080/marketplace/' + tipo + '/';
        }
        if (this.location.hostname.includes('hml')) {
            return 'https://api.hml.picpontos.com.br/marketplace/' + tipo + '/';
        }
        return 'https://api.picpontos.com.br/marketplace/' + tipo + '/';
    };

    public pathApi(): HttpService {
        this.path = this.getUrl('api');
        return this;
    }

    public pathRest(): HttpService {
        this.path = this.getUrl('rest');
        return this;
    }

    public pathApiReports(): HttpService {
        if (this.location.hostname === '127.0.0.1' || this.location.hostname === 'localhost') {
            this.path = 'http://localhost:9099/';
        } else {
            this.path = 'https://reports.inovahsol.com.br/';
        }

        return this;
    }

    public pathV2(): HttpService {
        this.path = this.getUrl('services/v2');
        return this;
    }

    private teste() {
        const a = 2 + 2;
    }

}// fim de HttpService



// WEBPACK FOOTER //
// ./src/app/resources/services/http.service.ts